import { purgeStoredState } from 'redux-persist';

import { basePersistConfig } from '~/redux/persistConfig';

export const getFeaturesFromURL = (): string => {
  const params = new URLSearchParams(window.location.search);

  return params.get('features') || '';
};

export const updatePersistFeatureFlag = (features: string): void => {
  if (features.includes('persist')) {
    localStorage.setItem('features', 'persist');
  } else {
    localStorage.removeItem('features');
    purgeStoredState(basePersistConfig);
  }
};

/**
 * Converts an array of objects into a map, using a specified identifier property as the key.
 * @example
 * const shapes = [{ id: 'sqr', name: "Square" }];
 * const shapesById = convertArrayToMap(shapes, 'id')
 * console.log(shapesById.sqr) // { id: 'sqr', name: 'Square' }
 */
export const convertArrayToMap = <T>(
  arr: T[],
  idProp: keyof T
): Record<string | number, T> =>
  arr.reduce(
    (map, item) => ({
      ...map,
      [item[idProp] as string | number]: item,
    }),
    {}
  );
